<template>
	<el-dialog class="agreeDialog" :visible="show" append-to-body @close="handleClose">
		<div slot="title">
			<div class="dislogTitle">
				岱屿画境平台创作者注册协议
			</div>
		</div>
		<div class="dislogConent">
			<div class="mainTitle f_w_700">岱屿画境平台创作者注册协议</div>
			<div class="subTitle d_f_a_c f_w_700">
				生效日期：
				<div class="f_w_400">[2025年12月31日]</div>
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				更新日期：
				<div class="f_w_400">[2025年12月31日]</div>
			</div>
			<div class="agreeContent subTitle t-indent f_w_700">
				欢迎您（以下简称“创作者”或“您”或“用户”）注册并使用由[杭州岱屿画境科技有限公司]（以下简称“平台”或“我们”）运营的“【岱屿画境】”（以下简称“平台”）提供的服务！
			</div>
			<div class="agreeContent subTitle t-indent f_w_700">
				在您点击“同意”或类似按钮完成注册程序，或以任何方式开始使用平台服务（包括但不限于上传、发布图片）之前，请您务必仔细阅读、充分理解本协议的全部内容，特别是其中免除或限制平台责任的条款、知识产权条款、争议解决条款等。
			</div>
			<div class="agreeContent subTitle t-indent f_w_700">
				您对本协议的同意或实际使用平台服务的行为，即表示您已充分阅读、理解并接受本协议的全部内容，并与平台达成协议，承诺接受本协议各项条款的约束。如果您不同意本协议的任何内容，或者无法准确理解本协议条款的含义，请立即停止注册或使用平台服务。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第一条 协议主体与定位
			</div>
			<div class="subTitle t-indent f_w_400">
				1.<span class="f_w_700">平台定位：【岱屿画境】</span>平台是为AI生成图片（以下简称“图片”）提供展示、交易、沟通及相关服务的网络信息中介平台。
				平台作为运营方本身不直接参与图片创作，也不对创作者上传图片的创作过程进行直接控制。
			</div>
			<div class="subTitle t-indent f_w_400">
				2.<span
					class="f_w_700">创作者定位：</span>您作为创作者，是图片的生成者、上传者、展示者及销售者。您理解并同意，您通过平台发布、展示、销售的图片，均为您利用AI工具生成的作品，您对其承担相应的法律责任。
			</div>
			<div class="subTitle t-indent f_w_400">
				3.本协议是您与平台运营方之间就使用平台服务所订立的合法协议。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第二条 平台服务内容
			</div>
			<div class="subTitle t-indent f_w_400">
				1.平台为您提供以下主要服务：
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 提供图片上传、存储、展示的技术支持；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 提供图片信息发布、搜索、浏览的功能；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 提供创作者与潜在买家进行沟通、议价的渠道；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 提供在线交易系统，促成图片的购买与销售；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 提供交易款项的托管（如适用）、结算服务；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 提供用户账户管理、作品管理等功能；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 提供基于创作者作品的周边产品开发、定制与销售服务；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 其他平台可能不时新增或调整的服务。
			</div>
			<div class="subTitle t-indent f_w_400">
				2.平台提供的所有服务均基于现有技术与资源。因业务调整、技术升级或其他合理原因，平台保留变更、中断或终止部分或全部服务的权利，且无需事先通知您。
				受限于现有技术条件及不可避免的网络环境、系统维护、升级等因素，平台无法保证服务在任何时候都是持续、及时、安全或无误的。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第三条 用户注册与账户
			</div>
			<div class="subTitle t-indent f_w_400">
				1.<span class="f_w_700">用户资格</span>
			</div>
			<div class="subTitle t-indent f_w_400">
				只有符合下列条件之一的自然人或法人才能申请成为本网站用户，可以使用本网站的服务：
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span> 年满十八岁，并具有民事权利能力和完全民事行为能力的自然人。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span> 限制民事行为能力人应经过其监护人的同意；
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span> 根据中国法律、法规、行政规章成立并合法存在的机关、企事业单位、社团组织和其他组织。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span> 如您不符合以上条件但使用本平台，您与本平台之间的协议自始无效，一经发现，本平台有权立即终止对您的服务；
				如行为已造成本平台损失或第三方损失的，应由您承担赔偿责任，本平台保留追究法律责任的权利。
			</div>
			<div class="subTitle t-indent f_w_400">
				（认证）用户需要提供明确的联系电话，并提供真实姓名或组织名称。
			</div>
			<div class="subTitle t-indent f_w_400">
				本网站用户须承诺遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性。
			</div>
			<div class="subTitle t-indent f_w_400">
				2.<span class="f_w_700">注册要求</span>
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span> 您承诺在注册时提供真实、准确、完整、有效的身份信息、联系方式、支付账户信息等，并保持该等信息的及时更新。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span> 您理解并同意，平台有权根据相关法律法规及政策要求，采取必要的技术和管理措施（如实名认证）对用户身份进行核验。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span> 用户在本网站注册的账号名称或账号下行为，不得有下列情形：
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="square"></span> 违反宪法或法律法规规定的；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="square"></span> 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="square"></span> 损害国家荣誉和利益的，损害公共利益的；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="square"></span> 煽动民族仇恨、民族歧视，破坏民族团结的；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="square"></span> 破坏国家宗教政策，宣扬邪教和封建迷信的；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="square"></span> 散布谣言，扰乱社会秩序，破坏社会稳定的；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="square"></span> 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="square"></span> 侮辱或者诽谤他人，侵害他人合法权益的；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="square"></span> 含有法律、行政法规禁止的其他内容的。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span> 您应妥善保管您的账户信息（包括用户名、密码等）及与账户相关的权限凭证。因您保管不善导致账户被盗用或任何其他损失，由您自行承担全部责任。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span> 您不得将账户转让、出借或分享给他人使用。您对账户下的一切行为承担法律责任。
			</div>
			<div class="subTitle t-indent f_w_400">
				3.<span class="f_w_700">账户安全：</span>如发现任何未经授权使用您账户或存在其他安全漏洞的情况，您应立即通知平台。平台有权根据您的请求或自行判断，采取暂停服务、冻结账户等措施。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第四条 知识产权
			</div>
			<div class="subTitle t-indent f_w_400">
				1.<span class="f_w_700">原创性与知识产权保证:</span>
			</div>
			<div class="subTitle t-indent f_w_400">
				您保证并承诺，您通过平台上传、发布、展示、销售的每一张图片：
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				您保证并承诺，您上传至平台的所有作品，均是利用正版AI工具生成 ，并进行了充分的、具有独创性的后期修改、编辑、调校或组合（如适用）。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				您保证并承诺，您是所上传作品的合法著作权人，对该作品享有完整、独立、无争议的著作权，有权授予本协议及平台规则所规定的许可。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				您承诺上传的作品不包含任何第三方（包括但不限于自然人、其他AI模型）的专有元素、受版权保护的内容（如知名动漫角色、受版权保护的摄影作品、艺术家独特风格等），除非您已获得该第三方的明确授权，并能应平台要求出示有效授权证明。
			</div>
			<div class="subTitle t-indent f_w_400">
				2.<span class="f_w_700">关于“个性化p值和提示词（Personalization &Prompt）”、模型与抄袭的特别约定:</span>
			</div>
			<div class="subTitle t-indent f_w_400">
				禁止直接抄袭：您严禁直接复制、照搬其他创作者或用户的未经授权的个性化P值（Personalization）提示词（Prompt）或者直接使用他人图片生成高度相似或相同的图片并用于销售。平台鼓励原创性思考和创新。
			</div>
			<div class="subTitle t-indent f_w_400">
				借鉴与创新的界限：允许受他人作品灵感启发而创作，但最终生成的作品必须在构图、色彩、主题、风格、细节等方面具有显著的独创性和可识别的差异性，而不能是简单的“微调”或“换色”。
			</div>
			<div class="subTitle t-indent f_w_400">
				平台的处理权：一旦平台收到关于作品涉嫌抄袭、模仿或使用未授权模型的投诉，平台有权根据初步证据暂时下架该作品。您有义务在指定期限内提供原创证明或使用授权证明。若无法提供，平台有权永久下架作品并依据规则对您的账户进行处理。
			</div>
			<div class="subTitle t-indent f_w_400">
				3.<span class="f_w_700">图片权利归属:</span>
			</div>
			<div class="subTitle t-indent f_w_400">
				您确认并声明，您对所上传图片享有完整的、可转让的相关权利（根据您生成图片时所使用的AI工具协议及适用法律确定），并有权通过平台进行展示和销售。
			</div>
			<div class="subTitle t-indent f_w_400">
				您授予平台的许可：您授予平台一项免费的许可，允许平台使用、展示、推广、复制您上传的作品，以及为提供服务和实现交易目的所必需的其他操作。
			</div>
			<div class="subTitle t-indent f_w_400">
				当买家购买您的作品时，即视为您授予该用户一项全球性、永久性、非排他性、不可再许可 的许可，允许其将作品用于个人或商业用途 （具体使用范围可在作品详情页明确注明，如是否允许印刷、衍生产品制作等）。
			</div>
			<div class="subTitle t-indent f_w_400">
				您理解并同意，当用户购买您的作品时，即视为您已根据所选定的售卖模式，向购买用户授予相应的许可或权利，并承诺对该等授权提供如下保障：
			</div>
			<div class="subTitle t-indent f_w_400">
				(1) 如售卖模式为个人欣赏使用许可（非独占），您承诺对该作品享有完整的知识产权，并保证可为多个买家合法、有效地授予非独占的使用许可；
			</div>
			<div class="subTitle t-indent f_w_400">
				(2) 如售卖模式为个人独家欣赏使用许可（独占），您承诺该作品未向任何第三方授予过任何权利，并保证买家享有独家的、非商业的欣赏使用权；
			</div>
			<div class="subTitle t-indent f_w_400">
				(3) 如售卖模式为有范围的商业许可，您承诺在约定范围内授权合法有效，且未与该许可范围冲突的第三方权利存在；
			</div>
			<div class="subTitle t-indent f_w_400">
				(4) 如售卖模式为完全买断许可，您承诺将该作品的著作权及其他一切相关知识产权永久性、不可撤销地、全球范围内排他性地转让给买家。
				您保证对该作品享有完整的处分权，该转让不侵犯任何第三方合法权益，且不存在任何权利负担或纠纷。
			</div>
			<div class="subTitle t-indent f_w_400">
				您进一步保证，您对作品的授权或转让符合中国法律法规，且具有合法有效的来源和处分资格。
			</div>
			<div class="subTitle t-indent f_w_400">
				4.<span class="f_w_700">平台权利:</span>
			</div>
			<div class="subTitle t-indent f_w_400">
				为提供平台服务之目的（例如展示、存储、推广、技术支持等），您授予平台一项全球性、非排他性、可再许可的、免版税的许可，允许平台使用、复制、修改（仅限技术性修改以适应平台展示）、传播、展示您上传的图片。
			</div>
			<div class="subTitle t-indent f_w_400">
				平台尊重您的知识产权。未经您另行书面许可，平台不会将您的图片用于本协议约定服务目的之外的其他商业用途（平台自身推广除外）。
			</div>
			<div class="subTitle t-indent f_w_400">
				平台仅为本次权利转让提供交易撮合和技术服务，并非转让方或受让方。
			</div>
			<div class="subTitle t-indent f_w_400">
				平台保留在发现或收到举报涉嫌侵权内容时，根据法律法规及本协议采取删除、屏蔽、断开链接等措施的权利。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第五条 发布内容合法性
			</div>
			<div class="subTitle t-indent f_w_400">
				1．您承诺并保证，您通过平台上传、发布、展示、传播的所有图片及任何相关信息（包括但不限于图片标题、描述、标签、与用户的沟通信息）：
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 严格遵守中华人民共和国法律法规、部门规章、政策规定；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 符合社会主义精神文明建设和社会主义核心价值观；
			</div>
			<div class="subTitle t-indent f_w_400">
				符合社会公序良俗，不包含以下内容：
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 反对宪法确定的基本原则的；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 损害国家荣誉和利益的；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 煽动民族仇恨、民族歧视，破坏民族团结的；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 破坏国家宗教政策，宣扬邪教和封建迷信的；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 散布谣言，扰乱社会秩序，破坏社会稳定的；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 侮辱或者诽谤他人，侵害他人合法权益的；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 含有法律、行政法规禁止的其他内容的。
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 不包含任何恶意软件、病毒、木马或其他有害代码；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 不进行任何虚假宣传或误导性陈述。
			</div>
			<div class="subTitle t-indent f_w_400">
				2.平台有权根据法律法规、政策要求及平台规则，对您发布的内容进行审核（包括但不限于人工审核、技术过滤），并有权拒绝发布、删除或屏蔽其认为不合规的内容，且无需向您承担任何责任。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第六条 用户的权利与义务
			</div>
			<div class="subTitle t-indent f_w_400">
				1.<span class="f_w_700">用户注册与账户管理</span>
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				用户不得以虚假信息骗取账号注册，账号名称、头像、简介等资料不得存在违法和不良信息。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				用户不得冒用关联机构或社会名人注册账号名称。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				用户不得以任何形式擅自转让或授权他人使用本平台账户。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				用户应妥善保管账户信息，并对账户下的所有行为承担法律责任。
			</div>
			<div class="subTitle t-indent f_w_400">
				2.<span class="f_w_700">信息发布规范</span>
			</div>
			<div class="subTitle t-indent f_w_400">
				用户有义务确保在平台上发布的需求信息真实、准确，无误导性。
			</div>
			<div class="subTitle t-indent f_w_400">
				用户在平台上发布需求、参与约稿等行为，不得违反国家法律法规，不得侵犯他人知识产权或其他合法权益，不得违背社会公共利益或公序良俗。
			</div>
			<div class="subTitle t-indent f_w_400">
				用户不得发布任何违法、欺诈、虚假或不道德的内容。
			</div>
			<div class="subTitle t-indent f_w_400">
				用户同意接收来自本网站的信息，包括但不限于活动信息、交易信息、促销信息等。
			</div>
			<div class="subTitle t-indent f_w_400">
				3.<span class="f_w_700">交易行为规范</span>
			</div>
			<div class="subTitle t-indent f_w_400">
				用户在平台交易中应当遵守诚实信用原则，不得以干预或操纵需求发布、以虚假资料认证创作者资格等不正当竞争方式扰乱交易秩序。
			</div>
			<div class="subTitle t-indent f_w_400">
				用户不应采取不正当手段（包括但不限于发布虚假需求、互换好评等）提高自身或他人信用度，或恶意评价其他用户。
			</div>
			<div class="subTitle t-indent f_w_400">
				用户不得违反支付结算相关法律法规，不得利用信用卡、第三方信用服务进行套现等违规操作。
			</div>

			<div class="subTitle t-indent f_w_400">
				4.<span class="f_w_700">禁止私下交易</span>
			</div>
			<div class="subTitle t-indent f_w_400">
				创作者理解并同意，其通过本平台展示、推广、销售作品过程中，不得利用平台提供的任何功能（包括但不限于作品展示、一键水印、站内沟通、社区发帖、个人主页联系信息等）引导用户进行任何形式的私下交易，
				包括但不限于引导用户至其他平台（如微信、QQ等社交软件）、其他网站或线下进行交易，以规避平台交易规则及应支付的服务费用。
			</div>
			<div class="subTitle t-indent f_w_400">
				平台有权利用技术手段对交易行为进行监控，如发现创作者存在私下交易行为。一经发现创作者存在上述违规行为，平台有权根据情节严重程度采取以下措施：
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				首次发现，对创作者账户予以警告，并下架相关涉嫌引导私下交易的内容；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				再次违规，平台有权暂停创作者账户部分或全部功能，冻结账户资金；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				情节严重或多次违规，平台有权永久封禁创作者账户，终止提供服务，并扣除账户内剩余款项作为违约金。平台同时保留追究创作者相应法律责任的权利。
			</div>
			<div class="subTitle t-indent f_w_400">
				本平台鼓励用户对创作者的违规行为进行举报。平台将对举报信息进行核实，并为举报人信息予以保密。对于核实有效的举报，平台将依据本条款进行处理。
			</div>
			<div class="subTitle t-indent f_w_400">
				5.<span class="f_w_700">内容使用规范</span>
			</div>
			<div class="subTitle t-indent f_w_400">
				用户上传的作品必须为原创或已获得合法授权，不得侵犯他人著作权、商标权、肖像权等合法权益。
			</div>
			<div class="subTitle t-indent f_w_400">
				用户通过平台购买的作品，其使用权范围以交易时约定的许可协议为准，不得超出约定范围使用。
			</div>
			<div class="subTitle t-indent f_w_400">
				未经平台书面许可，用户不得将平台任何内容用于商业用途（包括但不限于复制、修改、制作衍生作品等）。
			</div>
			<div class="subTitle t-indent f_w_400">
				6.<span class="f_w_700">纠纷处理</span>
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				用户在交易过程中如与其他用户产生纠纷，可请求平台协助调解。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				用户发现其他用户有违法或违反本协议的行为，可向平台举报。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				用户应自行承担因交易产生的相关费用，并依法纳税。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第七条 平台的权利与义务
			</div>
			<div class="subTitle t-indent f_w_400">
				1.<span class="f_w_700">服务保障</span>
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				平台有义务在现有技术条件下确保平台正常运行，尽力避免服务中断。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				平台应及时回复用户在注册和使用过程中遇到的问题和反馈。
			</div>
			<div class="subTitle t-indent f_w_400">
				2.<span class="f_w_700">管理权限</span>
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				平台有权对用户注册资料进行审查，对存在问题的资料有权要求用户解释或改正。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				如发生以下情形，平台有权限制用户活动、要求核实资料、发出警告或中止服务：
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="square"></span> 用户违反本协议或相关规则；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="square"></span> 收到第三方投诉且无法联系到用户核证；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="square"></span>明显存在违法或不当行为可能造成损害的情况。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				平台有权依据协议冻结、处置违规用户账户内的资金。
			</div>
			<div class="subTitle t-indent f_w_400">
				3.<span class="f_w_700">内容管理</span>
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				平台有权删除或限制以下信息：规避费用为目的；炒作信用为目的；存在欺诈或虚假内容；与交易无关；扰乱交易秩序；违反公共利益等。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				平台有权将用户公开作品及相关信息用于平台宣传推广（包括但不限于社交媒体、合作媒体、线下活动等），但应标明作者信息。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第八条 作品授权模式
			</div>
			<div class="subTitle t-indent f_w_400">
				1.售卖模式选择
			</div>
			<div class="subTitle t-indent f_w_400">
				创作者在发布作品时，必须从以下四种售卖模式中选择一种并明确设定。创作者应根据作品价值、授权范围及权利归属谨慎选择，一经设定，不得变更：
			</div>
			<div class="subTitle t-indent f_w_400">
				(1) 个人欣赏使用许可
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				授权性质：非独占性使用许可；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				适用范围：允许个人或公司以欣赏、个人收藏或非商业性使用（如壁纸、AI语聊背景等）为目的使用作品；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				权利保留：创作者保留作品完整知识产权，可继续向多个买家授予同类许可；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				买家限制：买家不得将作品用于任何商业用途或牟利行为。
			</div>
			<div class="subTitle t-indent f_w_400">
				(2) 个人独家欣赏使用许可（独占）
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				授权性质：独占性使用许可；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				适用范围：允许买家独家以欣赏、个人收藏或非商业性使用为目的使用作品；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				权利限制：创作者不得再次售卖该作品或许可任何第三方使用，买家不得将作品用于任何商业用途。
			</div>
			<div class="subTitle t-indent f_w_400">
				(3) 有范围的商业许可
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				授权性质：非独占性商业使用许可；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				适用范围：买家可在创作者明确授权的特定范围（如广告设计、产品包装、限定次数的营销使用等）或特定品类内，在特定时间中使用作品。
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				权利保留：创作者可继续将作品其他领域或其他品类出售给他人（个人欣赏或有限商业用途）。
			</div>
			<div class="subTitle t-indent f_w_400">
				(4) 完全买断许可
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				授权性质：著作权及相关知识产权全部转让；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				适用范围：创作者将作品的所有权、知识产权及其他一切权利永久性、排他性地转让给买家；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				权利限制：交易完成后，作品将从平台下架，创作者不得再以任何形式出售、使用或许可该作品。
			</div>
			<div class="subTitle t-indent f_w_400">
				2.特别约定
			</div>
			<div class="subTitle t-indent f_w_400">
				如作品已以任何形式（包括但不限于非独占的个人欣赏使用许可、独占的个人欣赏使用许可或有范围的商业许可）出售，创作者不可再选择"完全买断许可"模式进行售卖。平台将通过技术手段对已售作品进行监控，防止权利冲突。
			</div>
			<div class="subTitle t-indent f_w_400">
				平台提供技术保障，当作品以"完全买断许可"模式交易完成后，系统将自动下架该作品，确保不会发生重复授权。
			</div>
			<div class="subTitle t-indent f_w_400">
				3．服务费与结算
			</div>
			<div class="subTitle t-indent f_w_400">
				关于平台服务费的收取比例、计算方式、结算周期及支付方式等具体约定，详见平台另行制定的《创作者服务费收取与结算规则》。创作者同意并接受该规则的内容，并按照该规则进行收益结算。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第九条 免责声明
			</div>
			<div class="subTitle t-indent f_w_400">
				1.<span class="f_w_700">平台性质：平台仅作为网络服务提供者和交易组织者，</span>1．不对创作者上传的图片内容（包括其合法性、真实性、准确性、完整性、有效性）负责，
				也不对创作者与买家之间的交易行为（除平台提供的支付托管服务外）负责。
			</div>
			<div class="subTitle t-indent f_w_400">
				2.<span
					class="f_w_700">侵权责任：</span>如因您上传的图片内容侵犯他人合法权益或违反法律法规，导致平台遭受任何损失（包括但不限于赔偿金、和解金、律师费、行政罚款等直接及间接损失），您应负责全额赔偿。
			</div>
			<div class="subTitle t-indent f_w_400">
				3.<span
					class="f_w_700">服务可用性：</span>平台服务依其现状提供。平台尽力维护服务的稳定性与安全性，但对服务的中断、延迟、错误、数据丢失等不作担保，也不承担由此给您造成的损失（除非该损失由平台的故意或重大过失直接造成）。
			</div>
			<div class="subTitle t-indent f_w_400">
				4.<span
					class="f_w_700">第三方风险：</span>您理解并同意，与买家的沟通、交易存在一定风险（如欺诈、违约），您应自行判断并承担该等风险。平台对买家行为的合法性、履约能力等不作任何担保。
			</div>
			<div class="subTitle t-indent f_w_400">
				5.<span
					class="f_w_700">AI生成风险：</span>您理解AI生成图片的特性，平台对图片的质量、风格、是否符合预期、是否存在潜在伦理或法律风险（如深度伪造风险）等不作任何保证。您应自行评估并承担使用AI工具生成及销售图片的相关风险。
			</div>
			<div class="subTitle t-indent f_w_400">
				6.<span class="f_w_700">不可抗力：</span>因不可抗力（如自然灾害、政府行为、黑客攻击、电信故障等）导致平台无法提供服务或履行义务的，平台不承担责任。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第十条 违规处理
			</div>
			<div class="subTitle t-indent f_w_400">
				1．如您违反本协议的任何条款（特别是第四条、第五条关于知识产权和内容合法性的规定），或违反平台发布的其他规则、公告，平台有权根据违规行为的性质、情节严重程度及造成的后果，独立判断并采取以下一项或多项措施：
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				<span class="f_w_700">警告：</span>通过站内信、邮件等方式提醒您纠正违规行为。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				<span class="f_w_700">内容处置：</span>删除、屏蔽、下架违规图片及相关信息。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				<span class="f_w_700">限制功能：</span>限制您账户的部分功能（如禁止上传新图片、禁止发布评论、禁止与买家沟通）。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				<span class="f_w_700">账户冻结：</span>暂时冻结您的账户，冻结期间您将无法登录和使用平台服务。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				<span class="f_w_700">账户封禁：</span>永久关闭您的账户，终止向您提供服务，并清退账户内余额（如涉及违法所得，平台有权不予退还或依法处置）。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				<span class="f_w_700">追究责任：</span>平台保留向有关主管部门报告、移交司法机关处理以及依法追究您法律责任的权利。
			</div>
			<div class="subTitle t-indent f_w_400">
				2．平台对违规行为的认定和处理享有最终决定权。您同意平台行使该等权利的结果。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第十一条 保密
			</div>
			<div class="subTitle t-indent f_w_400">
				用户保证在使用本网站过程中所获悉的属于【岱屿画境】及他方的且无法自公开渠道获得的文件及资料（包括但不限于商业秘密、公司计划、运营活动、财务信息、技术信息、经营信息及其他商业秘密）予以保密。
				未经该资料和文件的原提供方同意，用户不得向第三方泄露该商业秘密的全部或者部分内容。但法律、法规、行政规章另有规定或者双方另有约定的除外。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第十二条 协议修改与终止
			</div>
			<div class="subTitle t-indent f_w_400">
				1．<span
					class="f_w_700">协议修改：</span>平台有权根据法律法规变化、业务调整、技术发展等原因，随时修改本协议。修改后的协议将在平台公布后生效。如您不同意修改后的协议，您有权停止使用平台服务。
				如您在修改生效后继续使用平台服务，则视为您接受修改后的协议。
			</div>
			<div class="subTitle t-indent f_w_400">
				2．<span class="f_w_700">协议终止：</span>
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				您有权随时通过注销账户的方式终止本协议（需符合平台注销流程）。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				平台有权根据本协议第八条（违规处理）的规定终止向您提供服务。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				无论因何种原因终止，本协议第四条（知识产权）、第五条（发布内容合法性）、第七条（免责声明）、第八条（违规处理）、第十条（法律适用与争议解决）等条款仍继续有效。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第十三条 法律适用与争议解决
			</div>
			<div class="subTitle t-indent f_w_400">
				1．法律适用：本协议的订立、效力、解释、履行和争议解决均适用中华人民共和国大陆地区法律（不包括冲突法）。
			</div>
			<div class="subTitle t-indent f_w_400">
				2．争议解决：因本协议引起的或与本协议有关的任何争议，双方应首先通过友好协商解决；协商不成的，任何一方均有权将争议提交至上海市普陀区人民法院管辖。
				败诉方应承担胜诉方全部的维权费用包括诉讼费用、聘请律师费用、公证费用等。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第十四条 其他
			</div>
			<div class="subTitle t-indent f_w_400">
				1.<span class="f_w_700">通知：</span>平台向您发出的通知，可通过平台公告、站内信、电子邮件、短信等方式进行。该等通知于发送之日视为已送达。
			</div>
			<div class="subTitle t-indent f_w_400">
				2.<span class="f_w_700">可分割性：</span>如果本协议的任何条款被认定为无效或不可执行，该条款应被修改以达到其预期目的，且不影响其他条款的效力。
			</div>
			<div class="subTitle t-indent f_w_400">
				3.<span
					class="f_w_700">完整协议：</span>本协议构成您与平台就本协议所涉事项达成的完整协议，取代任何先前的口头或书面约定。本协议与本平台公示的各项规则组成，相关名词可互相引用参照，如有不同理解，以本协议条款为准。
			</div>
			<div class="subTitle t-indent f_w_400">
				4.<span class="f_w_700">协议更新：</span>平台有权根据需要修改本协议。修改后会通过网站公告等方式通知您。若您继续使用平台服务，即视为接受修改后的协议。
			</div>
			<div class="subTitle t-indent f_w_400">
				5.<span class="f_w_700">标题：</span>本协议各条款的标题仅为方便阅读而设，不影响条款本身的含义或解释。
			</div>
			<div class="agreeContent subTitle t-indent f_w_700">
				再次提醒：在点击“同意”或开始使用平台服务前，请务必仔细阅读并理解本协议的全部内容。您的注册或使用行为即表示您同意接受本协议的约束。
			</div>
			<div class="agreeContent subTitle f_w_700">
				创作者服务费收取与结算规则
			</div>
			<div class="agreeContent subTitle f_w_700">
				制定方：[岱屿画境] 平台（以下简称"平台"）
			</div>
			<div class="agreeContent subTitle f_w_700">
				公司名称：杭州岱屿画境科技有限公司
			</div>
			<div class="agreeContent subTitle f_w_700">
				生效日期：[2025年12月31日]
			</div>
			<div class="agreeContent subTitle f_w_700">
				规则性质：本规则为《平台创作者注册协议》的有效组成部分
			</div>
			<div class="agreeContent subTitle f_w_700">
				重要提示：
			</div>
			<div class="agreeContent subTitle f_w_700">
				请在使用平台服务前仔细阅读本规则。当您以创作者身份在平台发布作品或以其他方式使用与收益结算相关的服务时，即表示您已充分阅读、理解并接受本规则的全部内容，同意受其约束。如您不同意本规则的任何内容，请立即停止使用本平台的服务。
			</div>
			<div class="agreeContent subTitle f_w_700">
				第一章 总则
			</div>
			<div class="agreeContent subTitle f_w_700">
				第一条【目的与依据】
			</div>
			<div class="agreeContent subTitle f_w_400">
				为规范平台创作者服务费的收取与结算行为，明确双方权利义务，根据《平台创作者注册协议》及相关法律法规，制定本规则。
			</div>
			<div class="agreeContent subTitle f_w_700">
				第二条【适用范围】
			</div>
			<div class="agreeContent subTitle f_w_400">
				本规则适用于所有在平台注册并通过平台销售作品的创作者（以下简称"创作者"）。
			</div>
			<div class="agreeContent subTitle f_w_700">
				第三条【术语定义】
			</div>
			<div class="agreeContent subTitle f_w_400">
				1．服务费：指平台根据本规则按比例从作品交易金额中收取的费用。
			</div>
			<div class="agreeContent subTitle f_w_400">
				2．结算金额：指扣除服务费、支付通道手续费及适用税费后，实际支付给创作者的金额。
			</div>
			<div class="agreeContent subTitle f_w_400">
				3．收款账户：指创作者在平台绑定的用于接收结算款项的有效账户。
			</div>
			<div class="agreeContent subTitle f_w_700">
				第二章 作品售卖模式
			</div>
			<div class="agreeContent subTitle f_w_700">
				第四条【售卖模式选择】
			</div>
			<div class="agreeContent subTitle f_w_400">
				创作者发布作品时，必须从以下四种售卖模式中至少选择一种并明确设定。创作者应根据作品价值、授权范围及权利归属谨慎选择：
			</div>
			<div class="agreeContent subTitle f_w_400">
				1．个人欣赏使用许可（非独占）
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				授权性质：非独占性使用许可。
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				适用范围：允许个人或公司以欣赏、个人收藏或非商业性使用（如壁纸、AI语聊头像或背景等）为目的使用作品。
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				权利保留：创作者保留作品完整知识产权，可继续向多个买家授予同类许可。
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				买家限制：买家不得将作品用于任何商业用途或牟利行为。
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				服务费比例：12%。
			</div>
			<div class="agreeContent subTitle f_w_400">
				2．个人独家欣赏使用许可（独占）
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				授权性质：独占性使用许可。
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				适用范围：允许买家独家以欣赏、个人收藏或非商业性使用为目的使用作品。
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				权利限制：创作者不得再次售卖该作品或许可任何第三方使用，买家不得将作品用于任何商业用途。
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				服务费比例：12%。
			</div>
			<div class="agreeContent subTitle f_w_400">
				3．有范围的商业许可
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				授权性质：非独占性商业使用许可。
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				适用范围：买家可在创作者明确授权的特定范围（如广告设计、产品包装、限定次数的营销使用等）或特定品类内，在特定时间中使用作品，品类+地域+时间+数量，例“仅限用于中国市场的A品牌产品包装，授权期为一年，产量不超过1万件”。
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				权利保留：创作者可继续将作品其他领域或其他品类出售给他人（个人欣赏或有限商业用途）。
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				服务费比例：12%。
			</div>
			<div class="agreeContent subTitle f_w_400">
				4. 完全买断许可
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				授权性质：著作权及相关知识产权全部转让。
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				适用范围：创作者将作品的所有权、知识产权及其他一切权利永久性、排他性地转让给买家。
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				权利限制：交易完成后，作品将从平台下架，创作者不得再以任何形式出售、使用或许可该作品。
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				服务费比例：14%。
			</div>
			<div class="agreeContent subTitle f_w_700">
				第三章 平台服务费与结算机制
			</div>
			<div class="agreeContent subTitle f_w_700">
				第六条【平台服务费计算】
			</div>
			<div class="agreeContent subTitle f_w_400">
				服务费按作品实际成交金额（扣除支付通道手续费前）乘以对应售卖模式的服务费比例计算。
			</div>
			<div class="agreeContent subTitle f_w_700">
				第七条【结算流程】
			</div>
			<div class="agreeContent subTitle f_w_400">
				1. 买家支付的款项由平台或其指定的第三方支付机构代收。
			</div>
			<div class="agreeContent subTitle f_w_400">
				2. 平台在每笔交易完成后，自动计算并扣除以下费用：
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				平台服务费
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				支付通道手续费（如有）
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				适用税费（如有）
			</div>
			<div class="agreeContent subTitle f_w_400">
				3. 在订单未完成或在售后期限内，该笔款项将由平台指定的第三方支付机构进行管托，订单确认或售后期届满后，转化为可提现金额，可结算至创作者绑定的收款账户。
			</div>
			<div class="agreeContent subTitle f_w_400">
				4. 结算金额支付至创作者绑定的有效收款账户。
			</div>
			<div class="agreeContent subTitle f_w_700">
				第八条【结算周期】
			</div>
			<div class="agreeContent subTitle f_w_400">
				1. 结算实行实时结算机制，但受支付机构处理时间影响，结算可能存在缓冲期（通常为1-3个工作日）。
			</div>
			<div class="agreeContent subTitle f_w_400">
				2. 具体结算周期、缓冲期及最低结算金额以平台公告或结算页面说明为准
			</div>
			<div class="agreeContent subTitle f_w_700">
				第九条【结算责任】
			</div>
			<div class="agreeContent subTitle f_w_400">
				1. 创作者须提供准确、有效的收款账户信息。因信息错误导致结算失败或延误的，由创作者自行承担责任。
			</div>
			<div class="agreeContent subTitle f_w_400">
				2. 创作者应自行承担收款账户可能产生的银行手续费等费用。
			</div>
			<div class="agreeContent subTitle f_w_400">
				3. 平台因系统维护、升级或其他不可抗力导致结算延迟的，应及时通知创作者，但不承担违约责任。
			</div>
			<div class="agreeContent subTitle f_w_700">
				第四章 双方权利义务
			</div>
			<div class="agreeContent subTitle f_w_700">
				第十条【平台义务】
			</div>
			<div class="agreeContent subTitle f_w_400">
				1. 及时处理结算异常情况，并在合理时间内完成结算。
			</div>
			<div class="agreeContent subTitle f_w_400">
				2. 对创作者的结算信息严格保密，不得泄露给第三方。
			</div>
			<div class="agreeContent subTitle f_w_400">
				3. 提供技术保障，保障创作者的权利实现。
			</div>
			<div class="agreeContent subTitle f_w_700">
				第十一条【创作者义务】
			</div>
			<div class="agreeContent subTitle f_w_400">
				1. 明确选择作品售卖模式，不得故意误导买家或规避服务费。
			</div>
			<div class="agreeContent subTitle f_w_400">
				2. 确保收款账户信息准确、有效，并及时更新变更信息。
			</div>
			<div class="agreeContent subTitle f_w_400">
				3.依法承担因交易产生的纳税义务（如有）。
			</div>
			<div class="agreeContent subTitle f_w_400">
				4.保证在选择"完全买断许可"模式时，该作品未向任何第三方授予过任何权利。
			</div>
			<div class="agreeContent subTitle f_w_400">
				5. 创作者保证并承诺其通过平台售卖的图片作品：
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				不侵犯任何第三方的知识产权、肖像权、隐私权等合法权益；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				符合国家法律法规、社会主义核心价值观和公序良俗；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				不包含任何违法、淫秽、暴力、恐怖、赌博等不良信息；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				不涉及任何违反国家安全和社会稳定的内容。
			</div>
			<div class="agreeContent subTitle f_w_400">
				6.
				创作者不得以任何形式规避平台服务费，包括但不限于与买家进行线下交易、通过非平台指定渠道收款等行为。创作者不得通过任何形式在本平台发布、展示、传递包含指向其他平台或渠道的信息、链接、二维码、联系方式等内容，不得以任何方式引导、诱导或促使用户离开本平台进行交流、交易或获取同类服务。
			</div>
			<div class="agreeContent subTitle f_w_400">
				平台有权利用技术手段对交易行为进行监控，如发现创作者存在私下交易行为，平台有权：
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				首次发现，对创作者账户予以警告，并下架相关涉嫌引导私下交易的内容；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				再次违规，平台有权暂停创作者账户部分或全部功能，冻结账户资金；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				情节严重或多次违规，平台有权永久封禁创作者账户，终止提供服务，并扣除账户内剩余款项作为违约金。平台同时保留追究创作者相应法律责任的权利。
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				本平台鼓励用户对创作者的违规行为进行举报。平台将对举报信息进行核实，并为举报人信息予以保密。对于核实有效的举报，平台将依据本条款进行处理。
			</div>
			<div class="agreeContent subTitle f_w_700">
				第五章 违约责任
			</div>
			<div class="agreeContent subTitle f_w_700">
				第十二条【违规处理】
			</div>
			<div class="agreeContent subTitle f_w_400">
				1. 创作者未按本规则选择售卖模式或提供虚假信息的，平台有权暂停结算直至问题解决。
			</div>
			<div class="agreeContent subTitle f_w_400">
				2. 因创作者原因导致权利冲突或结算失败的，平台不承担任何责任。
			</div>
			<div class="agreeContent subTitle f_w_400">
				3. 平台未按本规则及时结算的，创作者有权要求平台在合理期限内完成结算。
			</div>
			<div class="agreeContent subTitle f_w_700">
				第十三条【权利冲突责任】
			</div>
			<div class="agreeContent subTitle f_w_400">
				如因创作者选择不当导致不同买家之间发生权利冲突，由创作者自行承担全部法律责任，平台不承担任何连带责任。
			</div>
			<div class="agreeContent subTitle f_w_700">
				第六章 附则
			</div>
			<div class="agreeContent subTitle f_w_700">
				第十四条【规则修订】
			</div>
			<div class="agreeContent subTitle f_w_400">
				平台有权根据业务需要修订本规则，修订后的规则通过平台公告等方式公布后生效。规则修订后，创作者继续使用本平台进行交易的，视为同意本规则的修改。
			</div>
			<div class="agreeContent subTitle f_w_700">
				第十五条【争议解决】
			</div>
			<div class="agreeContent subTitle f_w_400">
				因本规则引起的争议，双方应友好协商解决；协商不成的，任何一方均有权向上海市普陀区人民法院提起诉讼。败诉方应承担胜诉方全部的维权费用包括诉讼费用、聘请律师费用、公证费用等。
			</div>
			<div class="agreeContent subTitle f_w_700">
				杭州岱屿画境科技有限公司
			</div>
			<div class="agreeContent subTitle f_w_700">
				2025年12月31日
			</div>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		props: {
			show: {
				type: Boolean,
				default: false
			}
		},
		methods: {
			handleClose() {
				this.$emit('close')
			}
		}
	}
</script>

<style lang="scss" scoped>
	.agreeDialog {

		::v-deep .el-dialog {
			width: 12rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem 0;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__headerbtn {
				top: .24rem;
				right: .24rem;
				font-size: .16rem;
			}

			&__body {
				height: 5rem;
				overflow-y: auto;
				padding: 0 .24rem .24rem;
				display: flex;
				flex-direction: column;
				align-items: center;
				font-weight: 400;
				font-size: .14rem;
				color: #252525;
			}
		}
	}

	.mainTitle {
		margin-top: .12rem;
		text-align: center;
	}

	.subTitle {
		margin-top: .12rem;
	}

	.t-indent {
		text-indent: 2em;
	}

	.d_f_a_c {
		display: flex;
		align-items: center;
	}

	.f_w_700 {
		font-weight: 700;
	}

	.f_w_400 {
		font-weight: 400;
	}

	.point {

		&::before {
			display: inline-block;
			margin-right: .04rem;
			content: '';
			width: .08rem;
			height: .08rem;
			background: #252525;
			border-radius: 50%;
		}
	}

	.square {

		&::before {
			display: inline-block;
			margin-right: .04rem;
			content: '';
			width: .08rem;
			height: .08rem;
			background: #252525;
			border-radius: .02rem;
		}
	}
</style>